export const APP_ROLE = Object.freeze({
    BCK_ADMIN: 'BCK_ADMIN',
    ACCOUNT_ADMIN: 'ACCOUNT_ADMIN',
    CLINIC_CARE_GIVER: 'CLINIC_CARE_GIVER',
    PATIENT: 'PATIENT',
    PATIENT_CARE_GIVER: 'PATIENT_CARE_GIVER',
    UNKNOWN: 'UNKNOWN'
});

const normalizeRawRoleName = (roleName) =>
    String(roleName || '')
        .trim()
        .toUpperCase()
        .replace(/\s+/g, '_');

export const resolveAppRole = (roleName) => {
    const normalized = normalizeRawRoleName(roleName);

    if (!normalized) {
        return APP_ROLE.UNKNOWN;
    }

    if (normalized === 'BCK_ADMIN') {
        return APP_ROLE.BCK_ADMIN;
    }

    if (normalized === 'ACCOUNT_ADMIN') {
        return APP_ROLE.ACCOUNT_ADMIN;
    }

    if (normalized === 'CLINIC_CARE_GIVER') {
        return APP_ROLE.CLINIC_CARE_GIVER;
    }

    if (normalized === 'PATIENT') {
        return APP_ROLE.PATIENT;
    }

    if (normalized === 'PATIENT_CARE_GIVER') {
        return APP_ROLE.PATIENT_CARE_GIVER;
    }

    return APP_ROLE.UNKNOWN;
};

const WEB_ALLOWED_ROLES = new Set([
    APP_ROLE.BCK_ADMIN,
    APP_ROLE.ACCOUNT_ADMIN,
    APP_ROLE.CLINIC_CARE_GIVER
]);

export const canAccessWebPlatform = (roleName) =>
    WEB_ALLOWED_ROLES.has(resolveAppRole(roleName));
